export enum LOGIN_MODAL_CHALLENGE_URL {
  FORGOT_LOGIN = '/login/login/getProfileForCustomer'
}
